import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import newRequest from "../../src/context/newRequest";

export const fetchSearchData = createAsyncThunk(
    "search/fetchData",
    async ({ path, params }) => {
        const {
            query,
            queryTicketId,
            queryStatusId,
            queryCustomer,
            queryMonth,
            queryYear,
            queryVendorId,
            regionId,
            order,
            startDate,
            endDate,
            page,
            pageSize
        } = params;

        const res = await newRequest.get(
            `/v1/${path}/query?userId=${query}&region_id=${regionId}&ticketId=${queryTicketId}&status_id=${queryStatusId}&site_customer=${queryCustomer}&month=${queryMonth}&year=${queryYear}&start_date=${startDate}&vendor_id=${queryVendorId}&end_date=${endDate}&order=${order}&page=${page}&pageSize=${pageSize}`
        );
        const data = res.data
        return data; // { data: [], paging: { total_item: ... } }
    }
);

const searchSlice = createSlice({
    name: "search",
    initialState: {
        // filters
        query: "",
        queryTicketId: "",
        queryStatusId: "",
        queryCustomer: "",
        queryMonth: "",
        queryYear: "",
        queryVendorId:"",
        regionId: "",
        startDate: "",
        endDate: "",
        order: "",

        // pagination + data
        data: [],
        total: 0,
        page: 1,
        pageSize: 10,
        loading: false,
    },

    reducers: {
        setField: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;

            // -------------------------------
            // 🔥 VALIDASI RANGE TANGGAL
            // -------------------------------
            if (name === "startDate" || name === "endDate") {
                const { startDate, endDate } = state;

                if (startDate && endDate) {
                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    // ❌ Start > End → sesuaikan otomatis
                    if (start > end) {
                        if (name === "startDate") {
                            state.startDate = endDate;
                        } else if (name === "endDate") {
                            state.endDate = startDate;
                        }
                    }
                }
            }
        },

        resetFilters: (state) => {
            state.query = "";
            state.queryTicketId = "";
            state.queryStatusId = "";
            state.queryCustomer = "";
            state.queryMonth = "";
            state.queryYear = "";
            state.regionId = "";
            state.endDate = null;
            state.startDate = null;
            state.order = "";
        },

        setPage: (state, action) => {
            state.page = action.payload;
        },

        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSearchData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSearchData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.total = action.payload.paging.total_item ;
            })
            .addCase(fetchSearchData.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { setField, resetFilters, setPage, setPageSize } = searchSlice.actions;
export default searchSlice.reducer;
